import { SVGProps } from 'react'

export const DiscoverWhite = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="27"
      height="15"
      viewBox="0 0 27 15"
      fill={props.color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M4.28978 5.9668H3.375V9.29093H4.28978C4.77334 9.29093 5.12325 9.17027 5.43207 8.91012C5.79928 8.59569 6.01468 8.12428 6.01468 7.63492C6.00905 6.64992 5.30404 5.9668 4.28978 5.9668ZM5.0242 8.46875C4.82611 8.64996 4.57568 8.73474 4.16738 8.73474H3.9987V6.5351H4.16781C4.57006 6.5351 4.81486 6.60776 5.02464 6.80108C5.24046 7.00068 5.36849 7.30883 5.36849 7.62909C5.36806 7.94934 5.2396 8.2696 5.0242 8.46875Z" />
      <path d="M6.92448 5.9668H6.30078V9.29093H6.92448V5.9668Z" />
      <path d="M8.44925 7.24011C8.07642 7.09523 7.96569 6.99834 7.96569 6.82296C7.96569 6.61125 8.16379 6.45426 8.43195 6.45426C8.61837 6.45426 8.7758 6.53276 8.93324 6.72608L9.2598 6.28472C8.99163 6.04295 8.67113 5.91602 8.3156 5.91602C7.7503 5.91602 7.31345 6.32688 7.31345 6.87096C7.31345 7.33026 7.5176 7.56575 8.10021 7.78374C8.34501 7.87434 8.46742 7.9349 8.53143 7.97123C8.65383 8.056 8.71785 8.17666 8.71785 8.31571C8.71785 8.58752 8.5137 8.78712 8.23429 8.78712C7.93715 8.78712 7.69796 8.63013 7.55263 8.34576L7.15039 8.75079C7.43585 9.19215 7.78576 9.38547 8.25764 9.38547C8.9047 9.38547 9.3649 8.93828 9.3649 8.29148C9.37614 7.75368 9.16032 7.51192 8.44925 7.24011Z" />
      <path d="M9.57031 7.63577C9.57031 8.61493 10.3104 9.37027 11.2602 9.37027C11.5283 9.37027 11.7615 9.316 12.0409 9.17695V8.41533C11.7904 8.67503 11.569 8.77775 11.2892 8.77775C10.6598 8.77775 10.2109 8.30633 10.2109 7.62949C10.2109 6.98897 10.6711 6.48705 11.2597 6.48705C11.5569 6.48705 11.7844 6.59605 12.0404 6.86158V6.09996C11.7667 5.95508 11.5391 5.89453 11.271 5.89453C10.3337 5.89498 9.57031 6.66871 9.57031 7.63577Z" />
      <path d="M17.0033 8.20277L16.1465 5.9668H15.4648L16.8225 9.37526H17.1608L18.5418 5.9668H17.8658L17.0033 8.20277Z" />
      <path d="M18.8301 9.29093H20.6017V8.72891H19.4538V7.83452H20.561V7.27205H19.4538V6.5351H20.6017V5.9668H18.8301V9.29093Z" />
      <path d="M23.0783 6.95182C23.0783 6.32925 22.6644 5.97266 21.9421 5.97266H21.0156V9.29679H21.6393V7.96104H21.7211L22.5835 9.29679H23.353L22.3448 7.89465C22.8162 7.79194 23.0783 7.45957 23.0783 6.95182ZM21.8197 7.50173H21.6389V6.49251H21.8314C22.2219 6.49251 22.4317 6.66161 22.4317 6.98815C22.4317 7.32052 22.2219 7.50173 21.8197 7.50173Z" />
      <path
        d="M13.9576 9.41082C14.9007 9.41082 15.6652 8.61798 15.6652 7.63998C15.6652 6.66197 14.9007 5.86914 13.9576 5.86914C13.0145 5.86914 12.25 6.66197 12.25 7.63998C12.25 8.61798 13.0145 9.41082 13.9576 9.41082Z"
        fill="url(#paint0_linear_2021_36823)"
      />
      <path
        opacity="0.65"
        d="M13.9576 9.53777C14.9007 9.53777 15.6652 8.74494 15.6652 7.76693C15.6652 6.78893 14.9007 5.99609 13.9576 5.99609C13.0145 5.99609 12.25 6.78893 12.25 7.76693C12.25 8.74494 13.0145 9.53777 13.9576 9.53777Z"
        fill="url(#paint1_linear_2021_36823)"
      />
      <path d="M23.4759 6.09451C23.4759 6.03396 23.4352 6.00391 23.3708 6.00391H23.2773V6.29411H23.3474V6.17929L23.4292 6.29411H23.5109L23.4175 6.17345C23.4525 6.16717 23.4759 6.13667 23.4759 6.09451ZM23.3591 6.13667H23.3474V6.05818H23.3591C23.3941 6.05818 23.4114 6.07029 23.4114 6.09451C23.4114 6.12456 23.3941 6.13667 23.3591 6.13667Z" />
      <path d="M23.3815 5.89453C23.2474 5.89453 23.1367 6.00936 23.1367 6.14841C23.1367 6.28745 23.2474 6.40228 23.3815 6.40228C23.5156 6.40228 23.6263 6.28745 23.6263 6.14841C23.6263 6.00936 23.5156 5.89453 23.3815 5.89453ZM23.3815 6.36012C23.2764 6.36012 23.1834 6.26951 23.1834 6.14841C23.1834 6.03358 23.2708 5.93669 23.3815 5.93669C23.4866 5.93669 23.574 6.03358 23.574 6.14841C23.574 6.26323 23.4866 6.36012 23.3815 6.36012Z" />
      <defs>
        <linearGradient
          id="paint0_linear_2021_36823"
          x1="14.8303"
          y1="9.05716"
          x2="13.5881"
          y2="7.18166"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F89F20" />
          <stop offset="0.2502" stopColor="#F79A20" />
          <stop offset="0.5331" stopColor="#F68D20" />
          <stop offset="0.6196" stopColor="#F58720" />
          <stop offset="0.7232" stopColor="#F48120" />
          <stop offset="1" stopColor="#F37521" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2021_36823"
          x1="14.644"
          y1="9.15832"
          x2="12.8174"
          y2="5.71555"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F58720" />
          <stop offset="0.3587" stopColor="#E16F27" />
          <stop offset="0.703" stopColor="#D4602C" />
          <stop offset="0.9816" stopColor="#D05B2E" />
        </linearGradient>
      </defs>
    </svg>
  )
}
